import { gql } from "@apollo/client";

export const GET_CONSUMER_DASHBOARD_DATA = gql`
  query consumerDashboardData($businessCustomerId: ID!) {
    consumerDashboardData(businessCustomerId: $businessCustomerId)
      {
        invoicesBalance{
          sundryInvoiceAmountDue
          totalAmountDue
          totalInvoicesDue
          unpaidSundryInvoices
        }
        activeBookings
        activeVehicles
        creditUtilisation {
          creditLimit
          available
          utilized
        }
        drivers {
          totalDrivers
          vehiclesAllocated
          availableDrivers
        }
        bookingStatus {
          totalVehicles
          daysInBooking
          endingThisMonth
        }
        serviceReminders {
          upcoming
          overdue
        }
        motReminders {
          upcoming
          failed
        }
        mileageOverview {
          mileageLimitExited
          approachingMileageLimits
        }
        vehicleCheckOverview {
          inProgressBookings
          completed
          pending
        }
      } 
  }`;

